import React from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Typography, Divider } from "antd";
import {
  CheckSquareOutlined,
  CloseSquareOutlined,
  FileSyncOutlined,
} from "@ant-design/icons";

const { Text, Title } = Typography;

function MenuReceivePayment({ onClick }) {
  const navigate = useNavigate();
  const ROLE_ID = localStorage.getItem("ROLE_ID");

  const handleMenuClick = (item) => {
    if (onClick) onClick(item.label); // ส่งชื่อไปที่ Header
    navigate(item.path);
  };

  const menuGroups = [
    {
      groupTitle: "รับชำระ",
      show: true,
      items: [
        {
          icon: <CheckSquareOutlined />,
          label: "รับชำระ > บันทึกรับรับชำระ",
          path: "/menu-manage-finance/main-receive-payment",
          show: true,
        },

        {
          icon: <CloseSquareOutlined />,
          label: "รับชำระ > ยกเลิกรับชำระ",
          path: "/menu-manage-finance/main-cancel-receive-payment",
          show: true,
        },

        {
          icon: <FileSyncOutlined />,
          label: "รับชำระ > ค้นหาใบเสร็จ",
          path: "/menu-manage-finance/main-reprint-receive-payment",
          show: true,
        },
      ],
    },
  ];

  return (
    <div className="dashboard-wrapper">
      {menuGroups.map(
        (group, gIndex) =>
          group.show && (
            <div key={gIndex}>
              <Divider orientation="left">
                <Title level={4}>{group.groupTitle}</Title>
              </Divider>
              <Row gutter={[24, 24]}>
                {group.items.map(
                  (item, index) =>
                    item.show && (
                      <Col xs={12} sm={8} md={6} lg={4} key={index}>
                        <div
                          className="menu-card"
                          onClick={() => handleMenuClick(item)}
                        >
                          <div className="icon-wrapper">{item.icon}</div>
                          <Text className="menu-text-gold">
                            {
                              item.label.includes(">")
                                ? item.label.split(">")[1] // ถ้ามี '>' ให้เอาตัวหลังสุดมาโชว์
                                : item.label // ถ้าไม่มีให้โชว์ปกติ
                            }
                          </Text>
                        </div>
                      </Col>
                    ),
                )}
              </Row>
            </div>
          ),
      )}
    </div>
  );
}

export default MenuReceivePayment;
